import React, { Fragment, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Stack from "@vapor/react-material/Stack";
import Divider from "@vapor/react-material/Divider";
import Table from "@vapor/react-material/Table";
import TableContainer from "@vapor/react-material/TableContainer";
import TableCell from "@vapor/react-material/TableCell";
import TableBody from "@vapor/react-material/TableBody";
import TableHead from "@vapor/react-material/TableHead";
import TableRow from "@vapor/react-material/TableRow";
import Paper from "@vapor/react-material/Paper";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const ImportAssociationPanel = ({
  t,
  importType,
  professionistaValues,
  provinciaValues,
  comuneValues,
  tipoIdentValues,
  tipoDocValues,
  users,
  importMappings,
  profPrestMappings,
  prestazioneOptions,
  provinceOptions,
  comuniOptions,
  tipoIdentOptions,
  tipoDocOptions,
  onMappingChange,
  onImportDateChange,
}) => {
  const selImportType = importType;
  const parsedArrProfList = professionistaValues;
  const parsedArrProvinceList = provinciaValues;
  const parsedArrComuniList = comuneValues;
  const parsedArrTipoIdentList = tipoIdentValues;
  const parsedArrTipoDocList = tipoDocValues;
  const utentiList = users;
  const mappedValuesList = importMappings;
  const mappedProfPrestList = profPrestMappings;
  const baseTipoPrestazioneList = prestazioneOptions;
  const baseProvinceList = provinceOptions;
  const baseComuniList = comuniOptions;
  const baseTipoIdentList = tipoIdentOptions;
  const baseTipoDocList = tipoDocOptions;
  const handleChange = onMappingChange;

  const [useImportDate, setUseImportDate] = useState(true);
  const dateOptions = [
    {
      label : "Usa la data presente nel file di import",
      value : true
    },
    {
      label : "Usa la data odierna",
      value : false
    }
  ]

  const handleImportDateChange = (e) => {
    const newValue = e.target.innerText === "Usa la data presente nel file di import";
    setUseImportDate(newValue);
    if (onImportDateChange) onImportDateChange(newValue);
  };

  return (
    <Stack direction="column" spacing={1} sx={{ width: "30%" }}>
      <ExtendedTypography variant="titleSmall" color="primary.main">
        {t("anagrafica.ImportDesktop.assInfo")}
      </ExtendedTypography>

      {selImportType === "aricdesktop" && parsedArrProfList.length > 0 ? (
        <Fragment>
          <Divider variant="standard" />
          <ExtendedTypography variant="body" color="primary.main">
            {t("anagrafica.ImportDesktop.prof")}
          </ExtendedTypography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="35%">Valore</TableCell>
                  <TableCell width="65%" align="right">
                    {t("anagrafica.ImportDesktop.assCon")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedArrProfList.map((item) => (
                  <Fragment key={uuidv4()}>
                    <TableRow
                      key={uuidv4()}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                      hover
                    >
                      <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">
                        {item}
                      </TableCell>
                      <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                        <Autocomplete
                          id="ddlProf"
                          size="small"
                          fullWidth
                          options={utentiList}
                          sx={{ width: "100%" }}
                          onChange={(e, v) => handleChange(e, v, item)}
                          isOptionEqualToValue={(option, value) =>
                            mappedValuesList.filter(
                              (x) => x.type === "professionista" && x.mappedValue === item
                            ).length === 0
                              ? option.userId === value.userId
                              : option.userId ===
                                mappedValuesList.filter(
                                  (x) => x.type === "professionista" && x.mappedValue === item
                                )[0].value
                          }
                          getOptionLabel={(option) => option.completeName}
                          defaultValue={
                            mappedValuesList.filter(
                              (x) => x.type === "professionista" && x.mappedValue === item
                            ).length > 0
                              ? utentiList.filter(
                                  (x) =>
                                    x.userId ===
                                    mappedValuesList.filter(
                                      (y) => y.type === "professionista" && y.mappedValue === item
                                    )[0].value
                                )[0]
                              : null
                          }
                          renderInput={(params) => (
                            <TextField {...params} required label="" sx={{ lineHeight: 1 }} />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow
                      key={uuidv4()}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                      hover
                    >
                      <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">
                        {t("anagrafica.ImportDesktop.assPrest")}
                      </TableCell>
                      <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                        <Autocomplete
                          id="ddlPrest"
                          size="small"
                          fullWidth
                          options={baseTipoPrestazioneList}
                          sx={{ width: "100%" }}
                          onChange={(e, v) => handleChange(e, v, item)}
                          getOptionLabel={(option) => option.nome}
                          defaultValue={
                            mappedProfPrestList.filter((x) => x.cf === item).length > 0
                              ? baseTipoPrestazioneList.filter(
                                  (x) =>
                                    x.id ===
                                    mappedProfPrestList.filter((y) => y.cf === item)[0].prestId
                                )[0]
                              : null
                          }
                          renderInput={(params) => (
                            <TextField {...params} required label="" sx={{ lineHeight: 1 }} />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      ) : null}

      {selImportType === "multi" && parsedArrProfList.length > 0 ? (
        <Fragment>
          <Divider variant="standard" />
          <ExtendedTypography variant="body" color="primary.main">
            {t("anagrafica.ImportDesktop.prof")}
          </ExtendedTypography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="35%">Valore</TableCell>
                  <TableCell width="65%" align="right">
                    {t("anagrafica.ImportDesktop.assCon")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedArrProfList.map((item) => (
                  <Fragment key={uuidv4()}>
                    <TableRow
                      key={uuidv4()}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                      hover
                    >
                      <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">
                        {item}
                      </TableCell>
                      <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                        <Autocomplete
                          id="ddlProf"
                          size="small"
                          fullWidth
                          options={utentiList}
                          sx={{ width: "100%" }}
                          onChange={(e, v) => handleChange(e, v, item)}
                          isOptionEqualToValue={(option, value) =>
                            mappedValuesList.filter(
                              (x) => x.type === "professionista" && x.mappedValue === item
                            ).length === 0
                              ? option.userId === value.userId
                              : option.userId ===
                                mappedValuesList.filter(
                                  (x) => x.type === "professionista" && x.mappedValue === item
                                )[0].value
                          }
                          getOptionLabel={(option) => option.completeName}
                          defaultValue={
                            mappedValuesList.filter(
                              (x) => x.type === "professionista" && x.mappedValue === item
                            ).length > 0
                              ? utentiList.filter(
                                  (x) =>
                                    x.userId ===
                                    mappedValuesList.filter(
                                      (y) => y.type === "professionista" && y.mappedValue === item
                                    )[0].value
                                )[0]
                              : null
                          }
                          renderInput={(params) => (
                            <TextField {...params} required label="" sx={{ lineHeight: 1 }} />
                          )}
                        />
                      </TableCell>
                    </TableRow>
                  </Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      ) : null}

      {parsedArrProvinceList.length > 0 ? (
        <Fragment>
          <Divider variant="standard" />
          <ExtendedTypography variant="body" color="primary.main">
            {t("anagrafica.ImportDesktop.prov")}
          </ExtendedTypography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="35%">Valore</TableCell>
                  <TableCell width="65%" align="right">
                    {t("anagrafica.ImportDesktop.assCon")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedArrProvinceList.map((item) => (
                  <TableRow
                    key={uuidv4()}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                    }}
                    hover
                  >
                    <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">
                      {item}
                    </TableCell>
                    <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                      <Autocomplete
                        id="ddlProvince"
                        size="small"
                        fullWidth
                        options={baseProvinceList}
                        sx={{ width: "100%" }}
                        onChange={(e, v) => handleChange(e, v, item)}
                        isOptionEqualToValue={(option, value) =>
                          mappedValuesList.filter(
                            (x) => x.type === "provincia" && x.mappedValue === item
                          ).length === 0
                            ? option.id === value.id
                            : option.id ===
                              parseInt(
                                mappedValuesList.filter(
                                  (x) => x.type === "provincia" && x.mappedValue === item
                                )[0].value
                              )
                        }
                        getOptionLabel={(option) => option.nome}
                        defaultValue={
                          mappedValuesList.filter(
                            (x) => x.type === "provincia" && x.mappedValue === item
                          ).length > 0
                            ? baseProvinceList.filter(
                                (x) =>
                                  x.id ===
                                  parseInt(
                                    mappedValuesList.filter(
                                      (y) => y.type === "provincia" && y.mappedValue === item
                                    )[0].value
                                  )
                              )[0]
                            : null
                        }
                        renderInput={(params) => (
                          <TextField {...params} required label="" sx={{ lineHeight: 1 }} />
                        )}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      ) : null}

      {parsedArrComuniList.length > 0 ? (
        <Fragment>
          <Divider variant="standard" />
          <ExtendedTypography variant="body" color="primary.main">
            {t("anagrafica.ImportDesktop.comuni")}
          </ExtendedTypography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="35%">Valore</TableCell>
                  <TableCell align="right" width="65%">
                    {t("anagrafica.ImportDesktop.assCon")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedArrComuniList.map((item) => (
                  <TableRow
                    key={uuidv4()}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                    }}
                    hover
                  >
                    <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">
                      {item}
                    </TableCell>
                    <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                      <Autocomplete
                        id="ddlComuni"
                        size="small"
                        fullWidth
                        options={baseComuniList}
                        sx={{ width: "100%" }}
                        onChange={(e, v) => handleChange(e, v, item)}
                        isOptionEqualToValue={(option, value) =>
                          mappedValuesList.filter(
                            (x) => x.type === "comune" && x.mappedValue === item
                          ).length === 0
                            ? option.id === value.id
                            : option.id ===
                              parseInt(
                                mappedValuesList.filter(
                                  (x) => x.type === "comune" && x.mappedValue === item
                                )[0].value
                              )
                        }
                        getOptionLabel={(option) => option.nome + " (" + option.provincia + ")"}
                        defaultValue={
                          mappedValuesList.filter(
                            (x) => x.type === "comune" && x.mappedValue === item
                          ).length > 0
                            ? baseComuniList.filter(
                                (x) =>
                                  x.id ===
                                  parseInt(
                                    mappedValuesList.filter(
                                      (y) => y.type === "comune" && y.mappedValue === item
                                    )[0].value
                                  )
                              )[0]
                            : null
                        }
                        renderInput={(params) => (
                          <TextField {...params} required label="" sx={{ lineHeight: 1 }} />
                        )}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      ) : null}

      {parsedArrTipoIdentList.length > 0 ? (
        <Fragment>
          <Divider variant="standard" />
          <ExtendedTypography variant="body" color="primary.main">
            {t("anagrafica.ImportDesktop.modIdent")}
          </ExtendedTypography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="35%">Valore</TableCell>
                  <TableCell align="right" width="65%">
                    {t("anagrafica.ImportDesktop.assCon")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedArrTipoIdentList.map((item) => (
                  <TableRow
                    key={uuidv4()}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                    }}
                    hover
                  >
                    <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">
                      {item}
                    </TableCell>
                    <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                      <Autocomplete
                        id="ddlTipoIdent"
                        size="small"
                        fullWidth
                        options={baseTipoIdentList}
                        sx={{ width: "100%" }}
                        onChange={(e, v) => handleChange(e, v, item)}
                        isOptionEqualToValue={(option, value) =>
                          mappedValuesList.filter(
                            (x) => x.type === "tipoIdent" && x.mappedValue === item
                          ).length === 0
                            ? option.id === value.id
                            : option.id ===
                              parseInt(
                                mappedValuesList.filter(
                                  (x) => x.type === "tipoIdent" && x.mappedValue === item
                                )[0].value
                              )
                        }
                        getOptionLabel={(option) => option.value}
                        defaultValue={
                          mappedValuesList.filter(
                            (x) => x.type === "tipoIdent" && x.mappedValue === item
                          ).length > 0
                            ? baseTipoIdentList.filter(
                                (x) =>
                                  x.id ===
                                  parseInt(
                                    mappedValuesList.filter(
                                      (y) => y.type === "tipoIdent" && y.mappedValue === item
                                    )[0].value
                                  )
                              )[0]
                            : null
                        }
                        renderInput={(params) => (
                          <TextField {...params} required label="" sx={{ lineHeight: 1 }} />
                        )}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      ) : null}

      {selImportType === "aricdesktop" && parsedArrTipoDocList.length > 0 &&
        (
          <Fragment>
            <Divider variant="standard" />            
            <TableContainer component={Paper}>
              <Table sx={{ width: "100%", mt: 0, mb: 2 }}>       
                <TableBody>                  
                  <TableRow>
                    <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">                    
                      Data di identificazione                          
                    </TableCell>
                    <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                      <Autocomplete
                        id="ddlDataIdent"
                        size="small"
                        fullWidth
                        options={dateOptions}
                        sx={{ width: "100%" }}
                        onChange={(e) => handleImportDateChange(e)}                        
                        getOptionLabel={(option) => option.label}
                        defaultValue={
                          useImportDate ? dateOptions[0] : dateOptions[1]
                        }
                        renderInput={(params) => (
                          <TextField {...params} required sx={{ lineHeight: 1 }} />
                        )}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>         
              </Table>
            </TableContainer>
          </Fragment>
        )
      }

      {parsedArrTipoDocList.length > 0 ? (
        <Fragment>   
          <Divider variant="standard" />       
          <ExtendedTypography variant="body" color="primary.main">
            {t("anagrafica.ImportDesktop.tipoDoc")}
          </ExtendedTypography>
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell width="35%">Valore</TableCell>
                  <TableCell align="right" width="65%">
                    {t("anagrafica.ImportDesktop.assCon")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {parsedArrTipoDocList.map((item) => (
                  <TableRow
                    key={uuidv4()}
                    sx={{
                      "&:last-child td, &:last-child th": {
                        border: 0,
                      },
                    }}
                    hover
                  >
                    <TableCell component="th" scope="row" sx={{ pl: 1 }} width="35%">
                      {item}
                    </TableCell>
                    <TableCell align="right" width="65%" sx={{ pr: 1 }}>
                      <Autocomplete
                        id="ddlModIdentDoc"
                        size="small"
                        fullWidth
                        options={baseTipoDocList}
                        sx={{ width: "100%" }}
                        onChange={(e, v) => handleChange(e, v, item)}
                        isOptionEqualToValue={(option, value) =>
                          mappedValuesList.filter(
                            (x) => x.type === "tipoDoc" && x.mappedValue === item
                          ).length === 0
                            ? option.id === value.id
                            : option.id ===
                              parseInt(
                                mappedValuesList.filter(
                                  (x) => x.type === "tipoDoc" && x.mappedValue === item
                                )[0].value
                              )
                        }
                        getOptionLabel={(option) => option.value}
                        defaultValue={
                          mappedValuesList.filter(
                            (x) => x.type === "tipoDoc" && x.mappedValue === item
                          ).length > 0
                            ? baseTipoDocList.filter(
                                (x) =>
                                  x.id ===
                                  parseInt(
                                    mappedValuesList.filter(
                                      (y) => y.type === "tipoDoc" && y.mappedValue === item
                                    )[0].value
                                  )
                              )[0]
                            : null
                        }
                        renderInput={(params) => (
                          <TextField {...params} required label="" sx={{ lineHeight: 1 }} />
                        )}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Fragment>
      ) : null}
    </Stack>
  );
};
